import { render, staticRenderFns } from "./create-edit-news.vue?vue&type=template&id=60c38bbf&scoped=true"
import script from "./create-edit-news.vue?vue&type=script&lang=js"
export * from "./create-edit-news.vue?vue&type=script&lang=js"
import style0 from "./create-edit-news.vue?vue&type=style&index=0&id=60c38bbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c38bbf",
  null
  
)

export default component.exports